export default __webpack_public_path__ + "static/media/TopAd3.69d6da5f.png";